import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'
import { FirstLevelHeader } from './FirstLevelHeader'
import { SecondLevelHeader } from './SecondLevelHeader'

interface Props {
  firstLevel?: boolean
  secondLevel?: boolean
  pathGoBack?: string
}

const HeaderRaw: React.SFC<RouteComponentProps<any> & Props> = ({ secondLevel, pathGoBack }) =>
  secondLevel ? <SecondLevelHeader pathGoBack={pathGoBack} /> : <FirstLevelHeader />

export const PrivateHeader = withRouter(HeaderRaw)



// WEBPACK FOOTER //
// ./src/views/components/Layout/PrivateHeader.tsx